export default __webpack_public_path__ + "static/media/28.b4373d00.jpg";